import React, { useState } from 'react';
import NadaPage from './NadaPage';
import NadaSession from './NadaSession';

const NadaContainer = ({ onBack }) => {
  const [activeMode, setActiveMode] = useState(null);

  if (activeMode) {
    return (
      <NadaSession
        mode={activeMode}
        onEnd={() => setActiveMode(null)}
      />
    );
  }

  return (
    <NadaPage
      onStart={(mode) => setActiveMode(mode)}
    />
  );
};

export default NadaContainer;
